import { useRef, useState } from "react";
import { SketchPicker } from "react-color";

import { useEventListener } from "../../../hooks/useWindow";
import { EventType } from "../../../constants";

interface ColorPickerProps {
  color: string;
  onChange: (color: string) => void;
  label?: string;
}

export const ColorPicker = ({ color, onChange, label }: ColorPickerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const colorPickerRef = useRef<HTMLDivElement>(null);

  useEventListener(EventType.MOUSE_DOWN, (e) => {
    if (!colorPickerRef.current?.contains(e.target as Node)) {
      setIsOpen(false);
    }
  });

  return (
    <div>
      {label && <label>{label}</label>}
      <div className="relative">
        <div
          className="flex w-fit cursor-pointer items-center rounded-md border p-1 focus:border-c1 dark:border-c1 dark:focus:border-c1"
          onClick={() => setIsOpen(true)}
        >
          <div
            className="h-9 w-9 rounded-lg"
            style={{ backgroundColor: color }}
          />
          {color && <span className="ml-1 mr-2">{color}</span>}
        </div>

        {isOpen && (
          <div
            ref={colorPickerRef}
            className="absolute bottom-full z-50 mb-2 rounded-lg border border-white-light bg-white p-2 dark:border-[#17263c] dark:bg-extraDark"
          >
            <SketchPicker
              color={color}
              onChange={(color) => onChange(color.hex)}
              disableAlpha={true}
              presetColors={[]}
              className={`
                [&_.flexbox-fix]:!bg-white 
                dark:[&_.flexbox-fix]:!bg-extraDark 
                [&_.flexbox-fix_input]:!rounded 
                [&_.flexbox-fix_input]:!bg-white 
                [&_.flexbox-fix_input]:!text-black 
                dark:[&_.flexbox-fix_input]:!bg-extraDark 
                dark:[&_.flexbox-fix_input]:!text-white

                [&_.flexbox-fix_label]:!w-8 
                [&_.flexbox-fix_label]:!text-center 
                [&_.flexbox-fix_label]:!text-black 
                [&_.flexbox-fix_label]:!opacity-100 
                dark:[&_.flexbox-fix_label]:!text-white 

                [&_.saturation-pointer]:!h-6 
                [&_.saturation-pointer]:!w-6 
                [&_.saturation-pointer]:!rounded-full 
                [&_.saturation-pointer]:!border-2 
                [&_.saturation-pointer]:!border-white  
                [&_.saturation]:!rounded-lg`}
              styles={{
                default: {
                  picker: {
                    boxShadow: "none",
                    backgroundColor: "transparent",
                  },
                },
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};
